import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';

@Injectable()
export abstract class ApiMutation<R, V> extends Mutation<
	{ [key: string]: R },
	V
> {
	abstract readonly method: string;
}
